import { TABLETDEVICEWIDTH } from "config/constants";
import { Content } from "gls/lib";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import React, { useRef } from "react";
import { colours } from "styling/colours";
import { media, style } from "typestyle";

type DropdownMenuProps = {
  children: React.ReactNode;
  onClose: () => void;
};

export const DropdownMenu = (props: DropdownMenuProps) => {
  const ref = useRef(null);
  useOutsideAlerter(ref, props.onClose);

  return (
    <Content className={wrapperStyle} ref={ref}>
      {props.children}
    </Content>
  );
};

const wrapperStyle = style(
  media(
    { maxWidth: TABLETDEVICEWIDTH },
    {
      right: '-25px',
      $nest: {
        "&:before": {
          right: "35px",
        },
        "&:after": {
          right: "36px",
        },
      }
    },
  ), {
  position: "absolute",
  top: "34px",
  padding: "12px 12px",
  minWidth: "180px",
  right: "-13px",
  backgroundColor: colours.white,
  border: `1px solid ${colours.lightBorder}`,
  zIndex: 9000,
  boxShadow:
    "4px 5px 8px 0 rgba(67, 86, 100, 0.12), -1px 2px 4px 0 rgba(67, 86, 100, 0.1)",
  $nest: {
    "&:after, &:before": {
      bottom: "100%",
      border: "solid transparent",
      content: '""',
      height: 0,
      width: 0,
      position: "absolute",
      pointerEvents: "none",
    },
    "&:before": {
      borderColor: "rgba(46, 46, 46, 0)",
      borderBottomColor: `${colours.lightBorder} !important`,
      borderWidth: "9px",
      right: '8px'
    },
    "&:after": {
      right: "9px",
      borderColor: "rgba(255, 255, 255, 0)",
      borderBottomColor: "#fff !important",
      borderWidth: "8px",
      marginLeft: "-8px",
    },
  },
});
